var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 33,
    viewBox: "0 0 22 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M15.9757 1.31317V20.7273C15.9757 21.2851 15.6253 21.7819 15.102 21.9659L1.73404 26.6681C0.886408 26.9662 0 26.3331 0 25.4294V5.88993C0 5.32812 0.3554 4.82865 0.883905 4.64771L14.2519 0.0709537C15.0976 -0.218595 15.9757 0.414152 15.9757 1.31317Z",
    fill: "#56BDF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M18.9618 4.31829V23.7324C18.9618 24.2902 18.6114 24.787 18.0881 24.9711L4.72012 29.6732C3.87249 29.9714 2.98608 29.3382 2.98608 28.4346V8.89505C2.98608 8.33325 3.34148 7.83378 3.86999 7.65284L17.238 3.07608C18.0837 2.78653 18.9618 3.41928 18.9618 4.31829Z",
    fill: "#C147F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M21.9479 7.32342V26.7375C21.9479 27.2953 21.5974 27.7922 21.0742 27.9762L7.7062 32.6783C6.85858 32.9765 5.97217 32.3433 5.97217 31.4397V11.9002C5.97217 11.3384 6.32757 10.8389 6.85607 10.658L20.2241 6.08121C21.0698 5.79166 21.9479 6.42441 21.9479 7.32342Z",
    fill: "#5353E7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c498a1ace9dd210b139d951dc9f3360b.svg";
export { ForwardRef as ReactComponent };